<template>
  <v-container>
    <div v-if="!connection">
      <v-alert type="error">
        Keine Verbindung zur Heizung! Möglicherweise Stromausfall..
      </v-alert>
    </div>
    <div v-else>
      <v-col cols="12">
        <h4>Ausgänge</h4>
        <relays></relays>
      </v-col>
      <v-col cols="12">
        <h4>Eingänge</h4>
        <inputs></inputs>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import Inputs from '../components/Inputs'
import Relays from '../components/Relays'

export default {
  name: 'Mails',
  components: {
    Inputs,
    Relays
  },
  data () {
    return {
      connection: false
    }
  },
  created () {
    setInterval(() => {
      this.getConnection()
    }, 1000)
  },
  methods: {
    getConnection () {
      this.$http.get('/api/connection').then((response) => {
        this.connection = response.data.connection
      })
    },
  }


};
</script>
